import { TripDates } from '@lx/quote-tool/shared/types';
import { CourseDetails } from '@lx/quote-tool/lite/shared/types';
import { AyaDuration, CourseTreeNode, GroupedAyaCourse } from '../../types';
import { Timezone } from '@lx/quote-tool/shared/types';
import { ClassTime } from '@lx/quote-tool/lite/online/types';
import { SchoolLocation } from '@lx/quote-tool/lite/shared/types';

/**
 * State of the Course Form component
 */
export interface CourseState {
  selectedLanguage?: string;
  selectedSchoolLocation?: SchoolLocation;
  selectedCourse?: CourseDetails;
  selectedDuration?: number;
  selectedAyaDuration?: AyaDuration;
  selectedStartDate?: string;
  selectedEndDate?: string;
  tripDates?: TripDates; // TODO remove from here and QuoteLiteState selectedStartDate and selectedEndDate and use only trip dates
  selectedClassTime?: ClassTime;
  selectedTimezone?: Timezone;

  // The tree structure of courses. We have it here as a centralized place, to avoid multiple calls to the API to get the same data.
  coursesTree?: CourseTreeNode[];

  // The aya courses. We have it here as a centralized place, to avoid multiple calls to the API to get the same data.
  ayaCourses?: GroupedAyaCourse[];
}
